export const sA = (arr: any[]): any[] => {
	if(!arr) {
		return [];
	}
	return arr;
};

export function lastItem<T = any>(arr: T[]): T | undefined {
	const list = sA(arr);
	return list.length > 0 ? list[list.length - 1] : undefined;
}



// WEBPACK FOOTER //
// ./src/core/util/ArrayUtil.ts